export default __webpack_public_path__ + "static/media/petClinic.d83ed8de.jpeg";